export const assetsColumns = [
  {label: "Asset Name", key:"Asset"},
  {label: "Site", key:"WindFarmName"},
  {label: "Manufacturer", key: "TBManufacturer"},
  {label: "Model", key: "TBModel"},
  {label: "Capacity (W)", key:"TBPowerW"},
  {label: "Health Status", key:"WTHealthStatus"},
  {label: "Last Inspection Date", key:"WTMostRecentInspection"},
];

export const assetsFilters = [
  "WindFarmName", "TBManufacturer", "TBModel", "WTHealthStatus"
];